import { render, staticRenderFns } from "./QuotationRecycle.vue?vue&type=template&id=3204370a&scoped=true&"
import script from "./QuotationRecycle.vue?vue&type=script&lang=js&"
export * from "./QuotationRecycle.vue?vue&type=script&lang=js&"
import style0 from "./QuotationRecycle.vue?vue&type=style&index=0&id=3204370a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204370a",
  null
  
)

export default component.exports